import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import { FastField, Field, useFormikContext } from "formik";
import { TextField } from "@mui/material";
import DropdownSelector from "../../atoms/Common/DropdownSelector.tsx";
import { getCatalogue } from "../../api/common/catalogues.ts";

export default function ProductVarnishForm() {
  const { values, setFieldValue } = useFormikContext() as any;

  // Initialize props structure for BRZ products
  useEffect(() => {
    // Only initialize if props is empty or doesn't have the BRZ structure
    if (!values.props || values.props.length === 0 || 
        !values.props.some((p: any) => p?.key === "F" || p?.key === "B" || p?.key === "S" || p?.key === "U")) {
      // Set up props structure: F for Finish, B for Brand, S for Specification, U for Unit
      const props = [
        { key: "F", value: "" }, // Finish
        { key: "S", value: "" }, // Specification
        { key: "U", value: "" }, // Unidad de medida
      ];
      setFieldValue("props", props);
    }
  }, [setFieldValue, values.props]);

  // Validation: Brand is optional if Specification is not empty, and vice versa
  const isSpecRequired = !values.props?.[1]?.value || (values.props[1]?.value as string)?.trim() === "";

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FastField
          fullWidth
          name="props.0.value"
          label="Acabado"
          as={DropdownSelector}
          fetchFunction={getCatalogue}
          fetchParams={{ catalogueName: "PRODUCT_FINISH", pageSize: 1000 }}
          keyField="id"
          required
        />
      </Grid>

      <Grid item xs={12}>
        <Field
          fullWidth
          name="props.1.value"
          label="Especificación"
          as={TextField}
          required={true}
          helperText={"Requerido"}
        />
      </Grid>

      <Grid item xs={12}>
        <FastField
          fullWidth
          name="props.2.value"
          label="Unidad de medida"
          as={DropdownSelector}
          fetchFunction={getCatalogue}
          fetchParams={{ catalogueName: "UNIT", pageSize: 1000 }}
          keyField="id"
        />
      </Grid>
    </Grid>
  );
}

